export function openWindowToReportingPage(reports = []) {
  //OLD:
  // const CODEPEN_LINK = "http://codepen.io/punkydrewster713/debug/aab0bddb3c51f19dcb94cb6b1c4265be?editors=1010";
  // const encodedString = encodeURIComponent( JSON.stringify(reports) );
  //
  // const url = `${CODEPEN_LINK}#reports=${encodedString}`;
  // window.open(url,'_blank');

  //NEW: (only 1 turnReporting)
  const CODEPEN_LINK =
    "https://codepen.io/punkydrewster713/pen/1ecb65050cb0be81ddfb7249a76a98df";
  const encodedString = encodeURIComponent(JSON.stringify(reports));

  const url = `${CODEPEN_LINK}#reports=${encodedString}`;
  window.open(url, "_blank");
}



// WEBPACK FOOTER //
// ./src/battle/open-window-to-reporting-page.js